import { makeStyles } from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles(({ palette: { primary, custom } }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    height: 32,
    margin: "0 4px",
    padding: "0 12px 0 8px",
    border: 0,
    background: "transparent",
    fontSize: "1rem",
    cursor: "pointer",
    outline: "none",
    borderRadius: 4,
    "&::before": {
      content: "''",
      position: "absolute",
      top: -4,
      right: -4,
      bottom: -4,
      left: -4,
    },
    "&:hover": {
      background: fade(custom.low, 0.1),
    },
    "&:focus": {
      boxShadow: `0 0 4px ${primary.main}`,
    },
  },
  root_compacted: {
    justifyContent: "center",
    width: 32,
    padding: "0 8px",
  },
  root_insideMore: {
    width: "100%",
    height: 36,
    margin: 0,
    borderRadius: 0,
    padding: "0 16px 0 12px",
    "&::before": {
      content: "none",
    },
  },
  icon: {
    marginRight: 8,
  },
  icon_compacted: {
    marginRight: 0,
  },
  icon_default: {
    fill: custom.grey[600],
  },
  icon_primary: {
    fill: primary.main,
  },
  text: {},
  text_compacted: {
    position: "absolute",
    top: -9999,
    overflow: "hidden",
  },
  text_default: {
    text: custom.grey[600],
  },
  text_primary: {
    color: primary.main,
  },
}));

export default useStyles;
